// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"61515f53","516":"5eaf3bce"}[chunkId] + ".chunk.css";
};